export default "__VITE_ASSET__c58061f4__"